import { useTranslation } from 'react-i18next';
import { LoginForm } from './login-form';
import classes from './index.module.css';
import { SeelEmail } from '../note';

// const LoginText = {
//   Title: i18n.t('To begin, please provide us with your order details'),
//   Tip: i18n.t('Need help? Contact us at'),
// };
export const EmailContact = () => {
  const { t } = useTranslation();
  const Tip = t('Need help? Contact us at');
  return (
    <section className={classes.tip}>
      <span>{Tip}</span>
      <SeelEmail style={{ fontSize: '14px', lineHeight: '20px' }} />
    </section>
  );
};

export const LoginPanel = () => (
  <section className={classes.panel_content}>
    <LoginForm />
  </section>
);
